// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"26455ac1","228":"325e6726","385":"ec337564","679":"185b7d4b","721":"6e64fea5","781":"2e71ce47"}[chunkId] + ".chunk.js";
};